let counterModulePromise;

const COUNTER_SELECTOR = "[data-counter]";

const loadCounterModule = () => {
	if (!counterModulePromise) {
		counterModulePromise = import("./counter.js");
	}
	return counterModulePromise;
};

export function counterEvents() {
	const counters = document.querySelectorAll(COUNTER_SELECTOR);
	if (!counters.length) {
		return;
	}

	if (!("IntersectionObserver" in window)) {
		loadCounterModule()
			.then(({ initCounter }) => {
				counters.forEach((counter) => initCounter(counter));
			})
			.catch((err) => {
				console.error("Failed to load counter module:", err);
			});
		return;
	}

	const observer = new IntersectionObserver(
		(entries, obs) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) {
					return;
				}
				const counter = entry.target;
				obs.unobserve(counter);
				loadCounterModule()
					.then(({ initCounter }) => initCounter(counter))
					.catch((err) => {
						console.error("Failed to load counter module:", err);
					});
			});
		},
		{ rootMargin: "0px 0px 200px 0px" }
	);

	counters.forEach((counter) => observer.observe(counter));
}
